import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

function SingleProduct(props) {
  const [auctionPrice, setAuctionPrice] = useState(
    parseFloat(props.currentBid) + 0.01
  );

  const handleAuctionPriceChange = (event) => {
    setAuctionPrice(event.target.value);
  };

  return (
    <div className={props.classList}>
      <img
        src={props.imgSrc}
        alt={props.name}
        style={{
          width: "200px",
          height: "200px",
          position: "relative",
          bottom: "20px",
        }}
      />

      {/* Product Content  */}
      <div className="product-content">
        <div
          className="product-top"
          style={{
            textAlign: "center",
          }}
        >
          <h5>{props.name}</h5>
          <div className="d-flex justify-content-between">
            <h6>{props.currentBid} ETH</h6>

            <div className="countdown-wrap">
              <ul className="countdown">
                <li>
                  <span className="hours">{props.endTime}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {props.seller !== props.address &&
        props.highestBidder !== props.address ? (
          <>
            <p
              className="me-auto hours text-white style--two"
              style={{
                textAlign: "center",
              }}
            >
              Bid Price in ETH:
            </p>
            <input
              type="number"
              className="form-control"
              id="bidPrice"
              min={parseInt(props.currentBid) + 0.01}
              step="0.01"
              value={auctionPrice}
              onChange={handleAuctionPriceChange}
              placeholder={parseInt(props.currentBid) + 0.01}
              required
            />
          </>
        ) : null}
        <div className="product-bottom">
          {/* Button Group  */}
          <div className="button-group">
            <button
              to="/pages/item-details"
              onClick={() =>
                props.seller === props.address
                  ? props.handleCancelAuction(props.tokenId)
                  : props.handlePlaceBid(
                      props.tokenId,
                      auctionPrice,
                      props.currentPrice
                    )
              }
              disabled={
                props.highestBidder === props.address &&
                props.seller !== props.address
              }
              className="btn btn-sm btn-border"
              style={{
                marginLeft: "60px",
              }}
            >
              <img src="/img/icons/judge-icon.svg" alt="" className="svg" />
              {props.seller === props.address ? "Cancel Auction" : "Place Bid"}
            </button>
          </div>
          {/* End Button Group  */}
        </div>
      </div>
      {/* End Product Content  */}
    </div>
  );
}

export default SingleProduct;
